import { ll_url } from "../../../../utils/tools";
import * as React from "react";

export function LogoUniprot({accession}: {accession: string}) {
  const link = `https://www.uniprot.org/uniprot/${accession}`;
  return (
    <a href={link} target="_blank" className="ll-logo-link">
      <img src={ll_url('/images/result/uniprot.svg')} style={{
        maxHeight: 'calc(1.2rem + 1rem + 5px)',  // section name font size + body top margin + header bottom padding
        height: '2rem',
      }} />
    </a>
  )
}